import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';
import { getThemeProps } from 'ravenjs/utils/theme';

const CompanyInfoTooltipStyled = styled.div`
    width: 100%;
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('CompanyInfoTooltip.styles')};
`;

const renderAddress = row => {
    const location = _get(row, 'location', {});

    if (_isEmpty(location)) {
        return 'No Address Found';
    }

    return (
        <span>
            {_get(location, 'address', '')},<br />
            {_get(location, 'city', 'city')}, {_get(location, 'state', 'state')} -{' '}
            {_get(location, 'zip', 'zip')}
        </span>
    );
};

const CompanyInfoTooltip = ({ row }) => (
    <CompanyInfoTooltipStyled>
        <Typography>
            <strong>Id:</strong>
            <br />
            {_get(row, 'companyId')}
        </Typography>
        <br />
        <Typography>
            <strong>Since:</strong>
            <br />
            {_get(row, 'companySince')}
        </Typography>
        <br />
        <Typography>
            <strong>Size:</strong>
            <br />
            {_get(row, 'companySize')}
        </Typography>
        <br />
        <Typography>
            <strong>Address:</strong>
            <br />
            {renderAddress(row)}
        </Typography>
    </CompanyInfoTooltipStyled>
);

CompanyInfoTooltip.propTypes = {
    /**
     * Properties of the current table-row
     */
    row: PropTypes.object,
};

CompanyInfoTooltip.defaultProps = {
    row: null,
};

export default CompanyInfoTooltip;
